import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Form, FormFeedback, Input, Nav, NavItem, NavLink, Offcanvas, OffcanvasBody, OffcanvasHeader, Spinner, TabContent, TabPane } from 'reactstrap';

// Redux
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { BaseCustomButton, BaseSelectComponent, DateUtil, userRoles } from '../../../shared';
// actions
import { getCoordinations } from '../../../store/catalogs/Coordinations/actions';
import { getServiceTypes } from '../../../store/catalogs/ServiceTypes/actions';
import { getCustomers } from '../../../store/catalogs/Customers/actions';
import { getLabAreas } from '../../../store/catalogs/LabAreas/actions';
import { getLabs } from '../../../store/catalogs/Laboratories/actions';
import { getLabSegments } from '../../../store/catalogs/LabSegments/actions';
import { getProducts } from '../../../store/catalogs/Products/actions';
import { getRegions } from '../../../store/catalogs/Regions/actions';
import { getUsers } from '../../../store/catalogs/Users/actions';
import { getLabRequest, updateLabRequest } from '../../../store/labCitec/labRequest/actions';
import { updateLabRequestTracking } from '../../../store/labCitec/labRequestTrackings/actions';

import classnames from 'classnames';
import Breadcrumb from '../../../components/Common/Breadcrumb';
import { LabRequestLastUpdate } from '../../../components/Common/LabRequestLastUpdate';
import Table1 from '../../../components/Common/TableContainer';
import { mainRequestStatusFilter, statuses } from '../../../constants';
import { LabCitecRequestSampleTab } from '../../lab-request-samples/components/LabCitecRequestSampleTab';
import { LabCitecDetailsReports } from './Information/Reports/LabCitecDetailsReports';
import { LabCitecDetailsTests } from './Information/Tests/LabCitecDetailsTests';

// Formik validation
import { useFormik } from 'formik';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Yup from 'yup';
import { EditIncidentCanvaModal } from '../../../components/Common/EditIncidentCanvaModal';
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal';
import baseUrl from "../../../helpers/baseurl";
import { dateToIso, retrieveCustomDate } from "../../../helpers/dateHelper";
import { getBusinessDateCountString } from '../../../helpers/mixFunctions';
import { addNewLabRequestIncident, deleteLabRequestIncident, getLabRequestIncidents, getLabRequestTests, updateLabRequestIncident } from '../../../store/actions';
import { AssignmentsTab } from '../Assignments/AssignmentsTab';
import QuotationsTab from '../Quotations/quotationsTab';
import { LabOperationTab } from './LabOperationTab';
import { LabCitecResultsTab } from './Results/results';
import { LabCitecSurveyTab } from './survey/satisfactionSurvey';

const LabCitecDetails = (props) => {

  const reqId = props.match.params.id;

  const [activeTab, setActiveTab] = useState(() => localStorage.getItem(`labCitecDetails_${reqId}_activeTab`) || '1');
  const [activeTab2, setActiveTab2] = useState(() => localStorage.getItem(`labCitecDetails_${reqId}_activeTab2`) || '1');
  const [activeTab3, setActiveTab3] = useState(() => localStorage.getItem(`labCitecDetails_${reqId}_activeTab3`) || '1');
  const [activeTab4, setActiveTab4] = useState(() => localStorage.getItem(`labCitecDetails_${reqId}_activeTab4`) || '1');
  const [disabled, setDisabled] = useState(true);

  const [incidentsCanva, setIncidentsCanva] = useState(false);
  const [writing, setWriting] = useState(false);

  // Sync active tabs state whenever request ID changes
  useEffect(() => {
    setActiveTab(localStorage.getItem(`labCitecDetails_${reqId}_activeTab`) || '1');
    setActiveTab2(localStorage.getItem(`labCitecDetails_${reqId}_activeTab2`) || '1');
    setActiveTab3(localStorage.getItem(`labCitecDetails_${reqId}_activeTab3`) || '1');
    setActiveTab4(localStorage.getItem(`labCitecDetails_${reqId}_activeTab4`) || '1');
  }, [reqId]);

  const profiletoggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      localStorage.setItem(`labCitecDetails_${reqId}_activeTab`, tab);
    }
  }

  const profiletoggle2 = tab => {
    if (activeTab2 !== tab) {
      setActiveTab2(tab);
      localStorage.setItem(`labCitecDetails_${reqId}_activeTab2`, tab);
    }
  }

  const profiletoggle3 = tab => {
    if (activeTab3 !== tab) {
      setActiveTab3(tab);
      localStorage.setItem(`labCitecDetails_${reqId}_activeTab3`, tab);
    }
  }

  const profiletoggle4 = tab => {
    if (activeTab4 !== tab) {
      setActiveTab4(tab);
      localStorage.setItem(`labCitecDetails_${reqId}_activeTab4`, tab);
    }
  }


  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  // Modal HOOKS
  const [rowInfo, setRowInfo] = useState();

  const obj = JSON.parse(localStorage.getItem("authUser"))

  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''

  const [user, setUser] = useState(obj.id);

  const labType = JSON.parse(localStorage.getItem("lType") ?? '')

  // * Redux
  const dispatch = useDispatch();

  const {
    labs,
    loading,
    labRequest,
    advisers,
    coordinations,
    labsegments,
    labareas,
    products,
    customers,
    regions,
    users,
    serviceTypes,
    labRequestIncidents,
    loadingIncidents,
    totalIncidents,
    currentPageIncidents
  } = useSelector(state => ({
    labRequests: state.labRequestReducer.labRequests,
    labs: state.labsReducer.labs,
    loading: state.labRequestReducer.loading,
    labRequest: state.labRequestReducer.labRequest,
    total: state.labRequestReducer.total,
    currentPage: state.labRequestReducer.currentPage,
    advisers: state.technicalAdvisers.technicalAdvisers,
    coordinations: state.coordinations.coordinations,
    labsegments: state.labSegments.labsegments,
    labareas: state.labAreas.labareas,
    products: state.products.products,
    regions: state.regions.regions,
    customers: state.customersReducer.customers,
    users: state.usersReducer.users,
    serviceTypes: state.serviceTypes.serviceTypes,

    labRequestIncidents: state.labRequestIncidentsReducer.labRequestIncidents,
    loadingIncidents: state.labRequestIncidentsReducer.loading,
    labRequestIncident: state.labRequestIncidentsReducer.labRequestIncident,
    totalIncidents: state.labRequestIncidentsReducer.total,
    currentPageIncidents: state.labRequestIncidentsReducer.currentPage,
  }), shallowEqual);
  // * Redux fin

  useEffect(() => {
    dispatch(getLabRequest(`/${props.match.params.id}`))
    dispatch(getLabRequestIncidents(`?limit=20&page=0&labRequest=${props.match.params.id}`));

    const timers = [];

    if (!coordinations || coordinations.length === 0) {
      dispatch(getCoordinations(`?limit=1000&page=0`))
    }

    timers.push(setTimeout(() => {
      if (!labsegments || labsegments.length === 0) {
        dispatch(getLabSegments(`?limit=1000&page=0`))
      }
    }, 100));

    timers.push(setTimeout(() => {
      if (!labareas || labareas.length === 0) {
        dispatch(getLabAreas(`?limit=1000&page=0&search=${labType}`))
      }
    }, 200));

    timers.push(setTimeout(() => {
      if (!products || products.length === 0) {
        if (labType === 'Móvil') {
          dispatch(getProducts(`?limit=1000&page=0&search=Móvil`))
        } else if (labType === 'CITEC') {
          dispatch(getProducts(`?limit=1000&page=0&search=CITEC`))
        }
      }
    }, 300));

    timers.push(setTimeout(() => {
      if (!customers || customers.length === 0) {
        dispatch(getCustomers(`?limit=1000&page=0`))
      }
    }, 400));

    timers.push(setTimeout(() => {
      if (!regions || regions.length === 0) {
        dispatch(getRegions(`?limit=4000&page=0`))
      }
    }, 500));

    timers.push(setTimeout(() => {
      if (!labs || labs.length === 0) {
        dispatch(getLabs(`?limit=1000&page=0&search=${labType}`))
      }
    }, 600));

    timers.push(setTimeout(() => {
      if (!users || users.length === 0) {
        dispatch(getUsers(`?limit=2000&page=0&recordStatus=enable`))
      }
    }, 700));

    timers.push(setTimeout(() => {
      if (!serviceTypes || serviceTypes.length === 0) {
        dispatch(getServiceTypes(`?limit=1000&page=0`))
      }
    }, 800));

    return () => {
      timers.forEach(clearTimeout);
    };
  }, [dispatch, labType, props.match.params.id])



  const booleanValidation = React.useMemo(
    () => !((labRequest.generalStatus === statuses.FINISHED || labRequest.generalStatus === statuses.CANCELLED) && (role !== userRoles.laboratorist)),
    [labRequest]
  );

  const validation = useFormik({
    enableReinitialize: true,
    validateOnChange: true,    // valida cada vez que cambie un valor
    validateOnBlur: true,      // valida cada vez que pierda el foco
    initialValues: {
      code: labRequest.code ?? '-',
      requestStatus: labRequest.requestStatus ?? '-',
      laboratoryArea: labRequest.laboratoryArea?.id ?? '',
      laboratory: labRequest.laboratory?.id ?? '',
      laboratorySegment: labRequest.laboratorySegment?.id ?? '',
      coordination: labRequest.coordination?.id ?? '',
      region: labRequest.region?.id ?? '',
      description: labRequest.description ?? '',
      customer: labRequest.customer?.id ?? '',
      product: labRequest.product?.id ?? '',
      technicalAdviser: labRequest.technicalAdviser
      ? {
          value: labRequest.technicalAdviser.id,
          label: `${labRequest.technicalAdviser.name} ${labRequest.technicalAdviser.surname}`
        }
      : null,
      requirements: labRequest.requirements ?? '',
      startedAt: labRequest.startedAt
        ? moment(labRequest.startedAt).format("YYYY-MM-DD HH:mm")
        : '',
      endedAt: labRequest.endedAt
        ? moment(labRequest.endedAt).format("YYYY-MM-DD HH:mm")
        : '',
      serviceType: labRequest.serviceType?.id ?? '',
    },
    validationSchema: Yup.object().shape({
      code: Yup.string().required("El código es obligatorio"),
      requestStatus: Yup.string().required("Seleccione un estatus"), 
      description: Yup.string().required("Descripción requerida"),
  
      region: Yup.string().required("Seleccione una región"),
      customer: Yup.string().required("Seleccione un cliente"),
      product: Yup.string().required("Seleccione un producto"),
      technicalAdviser: Yup.object().required("Seleccione un asesor técnico"),
  
      laboratory: Yup.string().required("Seleccione un laboratorio"),
      laboratoryArea: Yup.string().required("Seleccione un área de laboratorio"),
      laboratorySegment: Yup.string().required("Seleccione un segmento de laboratorio"),
      coordination: Yup.string().required("Seleccione una coordinación"),
      requirements: Yup.string().required("Requerimientos requeridos"),
      serviceType: Yup.string().required("Seleccione un tipo de servicio"),
    }),
    onSubmit: (values, { resetForm }) => {
      const updVal = {
        ...values,
        id: props.match.params.id,
        region: values.region?.value || values.region,
        customer: values.customer?.value || values.customer,
        product: values.product?.value || values.product,
        technicalAdviser: values.technicalAdviser?.value || values.technicalAdviser,
        laboratory: values.laboratory?.value || values.laboratory,
        laboratoryArea: values.laboratoryArea?.value || values.laboratoryArea,
        laboratorySegment: values.laboratorySegment?.value || values.laboratorySegment,
        coordination: values.coordination?.value || values.coordination,
        serviceType: values.serviceType?.value || values.serviceType,
      }
      if (updVal.endedAt === '') {
        delete updVal.endedAt
      }
      const { startedAt, ...rest } = updVal
      dispatch(updateLabRequest(rest))
      setTimeout(() => {
        dispatch(getLabRequest(`/${props.match.params.id}`))
      }, 200)
    }
  });

  const selectedAdviser = validation.values.technicalAdviser
    ? users.find(x => x.id === validation.values.technicalAdviser.value)
    : null;

  const validationIncidentsCanva = useFormik({
    enableReinitialize: true,
    initialValues: {
      incident: '',
    },
    validationSchema: Yup.object({

    }),
    onSubmit: (values, { resetForm }) => {

      const postVal = {
        ...values,
        labRequest: props.match.params.id,
      }
      dispatch(addNewLabRequestIncident(postVal));
      resetForm();
      setWriting(false);
    }
  });

  const refreshTable = () => {
    dispatch(getLabRequest(`/${props.match.params.id}`))
  }

  const updateSampleStatus = (values) => {
    const updVal = {
      ...values,
      user: user,
      percentage: values.trackingStatus === 'Autorizado' ? 100 : 0,
      datedAt: moment().format('YYYY-MM-DD')
    }
    dispatch(updateLabRequestTracking(updVal))
  }

  const updateTestStatus = (values) => {
    const updVal = {
      ...values,
      user: user,
      percentage: values.trackingStatus === 'Autorizado' ? 100 : 0,
      datedAt: moment().format('YYYY-MM-DD')
    }
    dispatch(updateLabRequestTracking(updVal))
  }

  const updateReportStatus = (values) => {
    const updVal = {
      ...values,
      user: user,
      percentage: values.trackingStatus === 'Autorizado' ? 100 : 0,
      datedAt: moment().format('YYYY-MM-DD')
    }
    dispatch(updateLabRequestTracking(updVal))
  }

  const updateLabOperationStatus = (values) => {
    const updVal = {
      ...values,
      user: user,
      percentage: values.trackingStatus === 'Autorizado' ? 100 : 0,
      datedAt: moment().format('YYYY-MM-DD')
    }
    dispatch(updateLabRequestTracking(updVal))
  }

  const updateAssignmentStatus = (values) => {
    const updVal = {
      ...values,
      user: user,
      datedAt: moment().format('YYYY-MM-DD'),
      silent: true
    }
    dispatch(updateLabRequestTracking(updVal))
  }

  const updateResultStatus = (values) => {
    const updVal = {
      ...values,
      user: user,
      percentage: values.trackingStatus === 'Autorizado' ? 100 : 0,
      datedAt: moment().format('YYYY-MM-DD')
    }
    dispatch(updateLabRequestTracking(updVal))
  }

  const updateSurveyStatus = (values) => {
    const updVal = {
      ...values,
      user: user,
      percentage: values.trackingStatus === 'Encuesta Realizada' ? 100 : 0,
      datedAt: moment().format('YYYY-MM-DD')
    }
    dispatch(updateLabRequestTracking(updVal))
  }

  const onUpdate = () => {
    if (disabled) {
    } else {
      validation.submitForm()
    }
    setDisabled(!disabled)
  }

  const onDelete = (values) => {
    setRowInfo(values);
    setShowModal2(true);
  }

  const onDeleteConfirmation = () => {
    dispatch(deleteLabRequestIncident(rowInfo));
    setRowInfo('');
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'Comentario',
        width: '71%',
        Cell: ({ row }) => (
          <>
            <div className='text-start text-primary'><strong>{`${row.original?.createdBy?.name ?? 'Name'} ${row.original?.createdBy?.surname ?? 'Surname'}`}</strong></div>

            <div className='text-start'>{row.original?.incident ?? '-'}</div>

            {
              booleanValidation ? <div className="d-flex align-items-center justify-content-end">
                <BaseCustomButton
                  color="primary"
                  className="rounded-3 me-2"
                  label="Editar"
                  onClick={() => booleanValidation ? onUpdateCanvaComment(row.original) : null}
                  outline={true}
                />
                <BaseCustomButton
                  color="danger"
                  className="rounded-3 me-2"
                  label="Eliminar"
                  onClick={() => booleanValidation ? onDelete(row.original) : null}
                  outline={true}
                />
              </div> : null
            }
          </>
        ),
      },
      {
        Header: 'Edición',
        accessor: 'updatedAt',
        width: '29%',
        Cell: ({ row }) => (
          <span className='' >{moment(row?.original?.updatedAt).format('YYYY-MM-DD HH:mm')}</span>
        ),
      },
    ],
    [booleanValidation]
  )

  const IncidentsCanva = () => {
    setIncidentsCanva(true);
  }

  const onCloseCanvas = () => {
    validationIncidentsCanva.resetForm();
  }

  const getPagination = (params) => {
    dispatch(getLabRequestIncidents(`${params}&labRequest=${props.match.params.id}`));
  }

  const onTextAreaFocus = () => {
    setWriting(true);
  }

  const onCancelNewComment = () => {
    validationIncidentsCanva.resetForm();
    setWriting(false);
  }

  const onUpdateCanvaComment = (values) => {
    setRowInfo(values);
    setShowModal1(true);
  }

  const modalRespInfo = (values) => {
    dispatch(updateLabRequestIncident(
      {
        ...values,
        id: rowInfo?.id,
      }
    ));
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="" >
          <Col className="col-12" style={{ padding: 40 }}>
            <Card className='' style={{ padding: 20 }}>
              {
                labType === 'CITEC' ?
                  <Breadcrumb breadcrumbItem1='labCitec' /> : <Breadcrumb breadcrumbItem1='labMoviles' />
              }

              <Card className='' style={{ padding: 20 }}>

                <div className="d-flex align-items-center justify-content-end mb-3">
                <Link
                  to={{
                    pathname: labType === 'Móvil' ? '/labmoviles' : '/labCitec',
                    query: {}
                  }}
                >
                  <BaseCustomButton
                    color="success"
                    className="rounded-3 py-2"
                    icon="mdi mdi-keyboard-backspace me-2"
                    label="Atrás"
                  />
                </Link>

                <BaseCustomButton
                  color="primary"
                  className="ms-2 py-2 my-0 rounded-3"
                  icon="mdi mdi-18px mdi-chevron-double-left"
                  onClick={IncidentsCanva}
                />

                  <Offcanvas
                    isOpen={incidentsCanva}
                    onClosed={onCloseCanvas}
                    direction="end"
                    toggle={() => { setIncidentsCanva(!incidentsCanva) }}
                  >
                    <OffcanvasHeader className='text-primary' toggle={() => { setIncidentsCanva(!incidentsCanva) }}>
                      <span className='text-primary'>Control de Incidencias</span>
                    </OffcanvasHeader>
                    <OffcanvasBody>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validationIncidentsCanva.handleSubmit();
                          return false;
                        }}
                      >
                        {
                          booleanValidation
                            ? <>
                              <label className='text-primary'>Comentario</label>
                              <textarea
                                required
                                type="text"
                                name="incident"
                                onFocus={onTextAreaFocus}
                                placeholder="Añadir un comentario"
                                onBlur={validationIncidentsCanva.handleBlur}
                                className="form-control text-primary rounded-3"
                                onChange={validationIncidentsCanva.handleChange}
                                value={validationIncidentsCanva.values.incident ?? ""}
                              />
                            </> : null
                        }

                        {
                          (writing)
                            ?
                            <div className='mt-2 mb-3 d-flex justify-content-start'>
                              <BaseCustomButton
                                type="submit"
                                color="success"
                                outline={true}
                                className="rounded-3 me-2"
                                icon="mdi mdi-content-save me-1"
                                label="Guardar"
                              />

                              <BaseCustomButton
                                color="danger"
                                className="rounded-3"
                                icon="mdi mdi-close-circle-outline me-1"
                                onClick={onCancelNewComment}
                                label="Cancelar"
                                outline={true}
                              />
                            </div>
                            : ''
                        }
                      </Form>

                      <Table1 currentPage={currentPageIncidents} getPagination={getPagination} total={totalIncidents} loading={loadingIncidents} isAddTableBorderStrap columns={columns}
                        data={
                          labRequestIncidents
                        } />
                      <EditIncidentCanvaModal props={props} showModal={showModal1} setShowModal={setShowModal1} modalRespInfo={modalRespInfo} modalHeader='Edición de incidencia' rowInfo={rowInfo} />
                      <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='¿Quieres eliminar ésta incidencia?' modalBodyLabel='Una vez eliminada, desaparecerá definitivamente' icon='warning' />
                    </OffcanvasBody>

                  </Offcanvas>

                </div>

                <Nav tabs className="nav-tabs-custom nav-justified">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => { profiletoggle('1'); }}>
                      Información de Solicitud</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink style={{ cursor: "pointer" }}
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => { profiletoggle('2'); }}>Asignaciones</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink style={{ cursor: "pointer" }}
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => { profiletoggle('3'); }}>Cotizaciones</NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="p-4">

                  <TabPane tabId='1'>
                    <div className="d-flex justify-content-between">
                      <div className='p-2'>
                      <Link
                        className="w-100"
                        to={{
                          pathname: `${baseUrl}lab-requests/export-to-excel/record/${props.match.params.id}`,
                        }}
                        target="_blank"
                      >
                        <BaseCustomButton
                          color="success"
                          className="rounded-3 w-100"
                          icon="mdi mdi-20px mdi-export p-2"
                          label="Exportar solicitud"
                          onClick={() => onUpdate()}
                        />
                      </Link>
                      </div>
                      <div className='ml-auto p-2'>
                      <BaseCustomButton
                        color="success"
                        className="rounded-3"
                        disabled={
                          (role === userRoles.laboratorist) ||
                          (role === userRoles.technicalAdvisor && labRequest.requestStatus !== statuses.SENT_PENDING) ||
                          labRequest.generalStatus === statuses.FINISHED ||
                          labRequest.generalStatus === statuses.CANCELLED ||
                          !validation.isValid 
                        }
                        onClick={onUpdate}
                        icon={
                          disabled
                            ? "mdi mdi-20px mdi-lead-pencil p-2"
                            : "mdi mdi-content-save me-1"
                        }
                        label={
                          disabled ? "Editar" : "Guardar"
                        }
                      />
                      </div>
                    </div>
                    {
                      loading ?
                        <div className="text-center py-5">
                          <Spinner
                            color="primary"
                          >
                          </Spinner>
                          <div className="row-center mt-2">
                            {' '}Cargando...
                          </div>
                        </div> :
                        <Form
                          className="form-horizontal mt-3 mb-1"
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                        >
                          <div className='row'>
                            <label className='text-info ml-1'>Información de Seguimiento</label> 
                            <div className="row ml-2 mr-2 mb-4">
                              <div className="col-3 col-md-3">
                                <LabRequestLastUpdate client={`${labRequest.createdBy?.name} ${labRequest.createdBy?.surname}`} date={moment(labRequest.updatedAt).format('YYYY-MM-DD HH:mm') ?? '-'} />
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Folio de Solicitud</label>
                                <Input
                                  disabled={true}
                                  name="code"
                                  className="form-control text-primary"
                                  placeholder="Código de Unidad de Medida"
                                  type="text"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.code ?? ""}
                                  invalid={
                                    !!(validation.touched.code && validation.errors.code)
                                  }
                                />
                                {validation.touched.code && validation.errors.code ? (
                                  <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                                ) : null}
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary ml-1'>Tipo de Laboratorio</label>
                                <BaseSelectComponent
                                  placeholder="Tipo de Laboratorio"
                                  disabled
                                  options={[
                                    { value: 'CITEC', label: 'CITEC' },
                                    { value: 'Móvil', label: 'Móvil' },
                                  ]}
                                  value={{
                                    value: labType,
                                    label: labType,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className='row'>
                            <div className="row ml-2 mr-2 mb-4">
                              <div className="col-3 col-md-3">
                                <label className='text-primary ml-1'>Fecha de recepción de muestras</label>
                                <div className='w-100 me-3'>

                                  {
                                    (disabled || role === userRoles.technicalAdvisor)
                                      ?
                                      (validation.values.startedAt)
                                        ? <Input disabled={true} className="form-control rounded-3 text-primary" value={validation.values.startedAt} />
                                        : <Input disabled={true} className="form-control rounded-3 text-primary" value={'aaaa/mm/dd hh:mm'} />
                                      :
                                      <Input
                                        disabled={true}
                                        required
                                        name="startedAt"
                                        className="form-control rounded-3 text-primary"
                                        type='text'
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.startedAt}
                                      />
                                  }
                                </div>
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary ml-1'>Fecha de aceptación de solicitud</label>
                                <div className='w-100 me-3'>

                                  {
                                    (disabled || role === userRoles.technicalAdvisor)
                                      ?
                                      (validation.values.endedAt)
                                        ? <Input disabled={true} className="form-control rounded-3 text-primary" value={validation.values.endedAt} />
                                        : <Input disabled={true} className="form-control rounded-3 text-primary" value={'aaaa/mm/dd hh:mm'} />
                                      :
                                      <Input disabled={disabled || role === userRoles.technicalAdvisor}
                                        required
                                        name="endedAt"
                                        className="form-control rounded-3 text-primary"
                                        type='date'
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.endedAt ? validation.values.endedAt.split(' ')[0] : ''}
                                      />
                                  }
                                </div>
                              </div>

                              <div className="col-3 col-md-3">
                                <label className='text-primary ml-1'>Cumplimiento de Tiempo de Atención</label>
                                <Input
                                  disabled={true}
                                  className="form-control text-primary"
                                  placeholder="Cumplimiento"
                                  type="text"
                                  value={
                                    (() => {
                                      const selectedServiceType = serviceTypes.find(st => st.id === validation.values.serviceType);
                                      const targetHours = selectedServiceType ? selectedServiceType.serviceTimeHours : 0;
                                      const startedAtDate = validation.values.startedAt ? new Date(validation.values.startedAt) : null;
                                      const endedAtDate = validation.values.endedAt ? new Date(validation.values.endedAt) : null;

                                      if (startedAtDate && endedAtDate && targetHours) {
                                        const diffMs = endedAtDate.getTime() - startedAtDate.getTime();
                                        const realHours = Math.ceil(diffMs / (1000 * 60 * 60));
                                        return realHours <= targetHours ? 'Cumple' : 'No Cumple';
                                      } else if (endedAtDate && labRequest.serviceTimeCompliance !== undefined && labRequest.serviceTimeCompliance !== null) {
                                        return labRequest.serviceTimeCompliance ? 'Cumple' : 'No Cumple';
                                      }
                                      return '-';
                                    })()
                                  }
                                />
                              </div>
                              <div className="col-3 col-md-3">
                                <label htmlFor="exampleFormControlInput1" className='text-primary'>Estatus de Solicitud</label>
                                <BaseSelectComponent
                                  placeholder="Estatus de Solicitud"
                                  options={mainRequestStatusFilter.map(dir => ({
                                    value: dir.id,
                                    label: dir.value,
                                  }))}
                                  value={
                                    validation.values.requestStatus
                                      ? {
                                          value: validation.values.requestStatus,
                                          label: mainRequestStatusFilter.find(opt => opt.id === validation.values.requestStatus)?.value ?? ''
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("requestStatus", sel?.value ?? "");
                                  }}
                                  error={validation.errors.requestStatus}
                                  touched={validation.touched.requestStatus}
                                  disabled
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <hr />
                            </div>
                            <div className='row'>
                              <label className='text-info ml-1'>Información General del Servicio</label>
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Área de Laboratorio</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione el área de laboratorio"
                                  options={labareas.map(dir => ({
                                    value: dir.id,
                                    label: dir.name,
                                  }))}
                                  value={
                                    validation.values.laboratoryArea
                                      ? {
                                          value: validation.values.laboratoryArea,
                                          label: labareas.find(a => a.id === validation.values.laboratoryArea)?.name ?? ""
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => 
                                    validation.setFieldValue("laboratoryArea", sel?.value ?? '')
                                  }
                                  error={validation.errors.laboratoryArea}
                                  touched={validation.errors.laboratoryArea}
                                  status={validation.errors.laboratoryArea ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Laboratorio</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione un laboratorio"
                                  options={labs.map(dir => ({
                                    value: dir.id,
                                    label: dir.name,
                                  }))}
                                  value={
                                    validation.values.laboratory
                                      ? {
                                          value: validation.values.laboratory,
                                          label: labs.find(l => l.id === validation.values.laboratory)?.name ?? ""
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("laboratory", sel?.value ?? "");
                                  }}
                                  error={validation.errors.laboratory}
                                  touched={validation.errors.laboratory}
                                  status={validation.errors.laboratory ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Tipo de Servicio</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione el tipo de servicio"
                                  options={serviceTypes.map(st => ({
                                    value: st.id,
                                    label: st.name,
                                  }))}
                                  value={
                                    validation.values.serviceType
                                      ? {
                                          value: validation.values.serviceType,
                                          label: serviceTypes.find(st => st.id === validation.values.serviceType)?.name ?? ""
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("serviceType", sel?.value ?? "");
                                  }}
                                  error={validation.errors.serviceType}
                                  touched={validation.touched.serviceType}
                                  status={validation.errors.serviceType ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>
                            </div>
                            <div className='row'>
                              <label className='text-info ml-1'>Información General del Servicio</label>
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Segmento de Laboratorio</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione un segmento"
                                  options={labsegments.map(dir => ({
                                    value: dir.id,
                                    label: dir.name,
                                  }))}
                                  value={
                                    validation.values.laboratorySegment
                                      ? {
                                          value: validation.values.laboratorySegment,
                                          label: labsegments.find(s => s.id === validation.values.laboratorySegment)?.name ?? ""
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("laboratorySegment", sel?.value ?? "");
                                  }}
                                  error={validation.errors.laboratorySegment}
                                  touched={validation.errors.laboratorySegment}
                                  status={validation.errors.laboratorySegment ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Coordinación</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione la coordinación"
                                  options={coordinations.map(dir => ({
                                    value: dir.id,
                                    label: dir.name,
                                  }))}
                                  value={
                                    validation.values.coordination
                                      ? {
                                          value: validation.values.coordination,
                                          label: coordinations.find(c => c.id === validation.values.coordination)?.name ?? ""
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("coordination", sel?.value ?? "");
                                  }}
                                  error={validation.errors.coordination}
                                  touched={validation.errors.coordination}
                                  status={validation.errors.coordination ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Localidad (estado-municipio)</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione Localidad..."
                                  options={regions.map(r => ({
                                    value: r.id,
                                    label: `${r.state ?? '-'} ${r.municipality ?? '-'}`,
                                  }))}
                                  value={
                                    validation.values.region
                                      ? {
                                          value: validation.values.region,
                                          label: (() => {
                                            const regionObj = regions.find(reg => reg.id === validation.values.region);
                                            return regionObj
                                              ? `${regionObj.state}-${regionObj.municipality}`
                                              : "";
                                          })()
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("region", sel?.value ?? "");
                                  }}
                                  error={validation.errors.region}
                                  touched={validation.errors.region}
                                  status={validation.errors.region ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>
                            </div>
                          </div>
                          <div className='row mt-2'>
                            <div className="col-12 col-md-12 mr-1">
                              <label htmlFor="exampleFormControlTextarea1" className='text-primary'>Descripción</label>
                              <Input
                                name="description"
                                required
                                disabled={disabled}
                                className={`form-control rounded-3 ${validation.touched.description && validation.errors.description ? 'is-invalid' : 'text-primary'}`}
                                rows="3"
                                placeholder="Descripción"
                                type="textarea"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.description ?? ""}
                              />
                              {validation.touched.description && validation.errors.description ? (
                                <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                              ) : null}
                            </div>
                          </div>

                          <div className='row mt-3'>
                            <hr />
                          </div>

                          <div className='row mt-2'>
                            <label className='text-info ml-1'>Información Control Interno</label>
                            <div className="row ml-2 mr-2 mb-4">

                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Nombre del Cliente</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione Cliente..."
                                  options={customers.map(cust => ({
                                    value: cust.id,
                                    label: cust.name,
                                  }))}
                                  value={
                                    validation.values.customer
                                      ? {
                                          value: validation.values.customer,
                                          label: customers.find(c => c.id === validation.values.customer)?.name ?? ""
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("customer", sel?.value ?? "");
                                  }}
                                  error={validation.errors.customer}
                                  touched={validation.errors.customer}
                                  status={validation.errors.customer ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>

                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Producto</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione Producto..."
                                  options={products.map(prod => ({
                                    value: prod.id,
                                    label: prod.name,
                                  }))}
                                  value={
                                    validation.values.product
                                      ? {
                                          value: validation.values.product,
                                          label: products.find(p => p.id === validation.values.product)?.name ?? ""
                                        }
                                      : null
                                  }
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("product", sel?.value ?? "");
                                  }}
                                  error={validation.errors.product}
                                  touched={validation.errors.product}
                                  status={validation.errors.product ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>

                            </div>
                          </div>
                          <div className='row mt-2'>
                            <label className='text-info ml-1'>Información Particular del Servicio</label>
                            <div className="row ml-2 mr-2 mb-4">
                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Asesor Técnico</label>
                                <BaseSelectComponent
                                  placeholder="Seleccione Asesor Técnico..."
                                  options={users
                                    .filter(x => x.userType === 'Asesor Técnico')
                                    .map(tech => ({
                                      value: tech.id,
                                      label: `${tech.name ?? '-'} ${tech.surname ?? ''}`,
                                    }))
                                  }
                                  value={validation.values.technicalAdviser}
                                  onChangeAsObject={true}
                                  onChange={(sel) => {
                                    validation.setFieldValue("technicalAdviser", sel);
                                  }}
                                  error={validation.errors.technicalAdviser}
                                  touched={validation.errors.technicalAdviser}
                                  status={validation.errors.technicalAdviser ? 'error' : ''}
                                  disabled={disabled}
                                />
                              </div>

                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Firma</label>
                                <Input
                                  type="text"
                                  disabled={true}
                                  placeholder='Firma del Asesor Técnico'
                                  className="form-control text-primary rounded-3"
                                  value={(selectedAdviser) ? selectedAdviser.signature : '-'}
                                />
                              </div>

                              <div className="col-3 col-md-3">
                                <label className='text-primary'>Teléfono</label>
                                <Input
                                  name="phone"
                                  required
                                  disabled={true}
                                  className="form-control text-primary rounded-3"
                                  placeholder="55-4524-0707"
                                  type="text"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={(selectedAdviser) ? selectedAdviser.phone : '-'}
                                />
                              </div>
                              <div className="col-3 col-md-3">
                                <label className='text-primary ml-1'>Fecha de Solicitud</label>
                                <div className='w-100 me-3'>
                                  <Input
                                    disabled={true}
                                    className="form-control rounded-3 text-primary"
                                    value={retrieveCustomDate(
                                      labRequest.requestStatus,
                                      labRequest.updatedAt,
                                      labRequest.createdAt,
                                      labRequest.createdRecordAt
                                    )}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                          <div className='row mt-2'>
                            <div className="row ml-2 mr-2 mb-4">
                              <div className="col-3 col-md-3">
                                <label htmlFor="exampleFormControlInput1" className='text-primary'>E-Mail</label>
                                <Input
                                  name="email"
                                  required
                                  className="form-control text-primary rounded-3"
                                  placeholder="name@example.com"
                                  type="email"
                                  disabled={disabled}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={(selectedAdviser) ? selectedAdviser.email : '-'}
                                />
                              </div>

                              <div className="col-3 col-md-9">
                                <label htmlFor="exampleFormControlInput1" className='text-primary'>Domicilio</label>
                                <Input
                                  required
                                  name="address"
                                  className="form-control text-primary rounded-3"
                                  placeholder="Domicilio"
                                  type="text"
                                  disabled={disabled}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={(selectedAdviser) ? selectedAdviser.address : '-'}
                                />
                              </div>

                            </div>
                          </div>

                          <div className='row mt-2 mb-3'>
                            <div className="col-12 col-md-12 mr-1">
                              <label htmlFor="exampleFormControlTextarea1" className='text-primary'>Requerimientos especiales u observaciones</label>
                              <textarea
                                name="requirements"
                                required
                                disabled={disabled}
                                className={`form-control rounded-3 ${validation.touched.requirements && validation.errors.requirements ? 'is-invalid' : 'text-primary'}`}
                                rows="3"
                                placeholder="Requerimientos"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.requirements ?? ""}
                              />
                              {validation.touched.requirements && validation.errors.requirements && (
                                  <FormFeedback>{validation.errors.requirements}</FormFeedback>
                              )}
                            </div>
                          </div>

                        </Form>
                    }
                    <Nav tabs className="nav-tabs-custom nav-justified">

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({ active: activeTab2 === '1' })}
                          onClick={() => { profiletoggle2('1'); dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${props.match.params.id}`)); }}
                        >
                          Solicitud de Servicio
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({ active: activeTab2 === '2' })}
                          onClick={() => { profiletoggle2('2'); }}
                        >
                          Operación de Laboratorio
                        </NavLink>
                      </NavItem>

                    </Nav>

                    <TabContent activeTab={activeTab2} className="p-4 px-0">
                      <TabPane tabId="1">
                        <Nav tabs className="d-flex nav-tabs-custom justify-content-between">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({ active: activeTab3 === '1' })}
                              onClick={() => { profiletoggle3('1'); }}
                            >
                              Solicitud de análisis | Avance {((labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.percentage +
                                labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.percentage +
                                labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.percentage) / 3).toFixed(2) ?? ''} %
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({ active: activeTab3 === '2' })}
                              onClick={() => { profiletoggle3('2'); }}
                            >
                              Entrega de resultados | Avance: {labRequest?.labRequestTracking?.find(x => x.stepTracking === 'Entrega de Resultados')?.percentage.toFixed(2) ?? ''} %
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({ active: activeTab3 === '3' })}
                              onClick={() => { profiletoggle3('3'); }}
                            >
                              Encuesta de satisfacción | Avance: {labRequest?.labRequestTracking?.find(x => x.stepTracking === 'Encuesta de Satisfacción')?.percentage.toFixed(2) ?? ''} %

                            </NavLink>
                          </NavItem>

                        </Nav>

                        <TabContent activeTab={activeTab3} className="p-4 px-0">

                          <TabPane
                            key={1}
                            tabId="1"
                          >
                            <Nav tabs className="d-flex nav-tabs-custom justify-content-start">
                              <NavItem className='px-5'>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({ active: activeTab4 === '1' })}
                                  onClick={() => { profiletoggle4('1'); }}
                                >
                                  Muestras | Avance {labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de muestras')?.percentage.toFixed(2) ?? ''} %

                                </NavLink>
                              </NavItem>

                              <NavItem className='px-5'>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({ active: activeTab4 === '2' })}
                                  onClick={() => { profiletoggle4('2'); }}
                                >
                                  Ensayos | Avance: {labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de ensayos')?.percentage.toFixed(2) ?? ''} %
                                </NavLink>
                              </NavItem>

                              <NavItem className='px-5'>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({ active: activeTab4 === '3' })}
                                  onClick={() => { profiletoggle4('3'); }}
                                >
                                  Informes | Avance: {labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.percentage.toFixed(2) ?? ''} %

                                </NavLink>
                              </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab4} className="p-0 px-0">

                              <TabPane tabId="1">
                                <LabCitecRequestSampleTab
                                  generalStatus={labRequest.generalStatus}
                                  status={validation.values.requestStatus}
                                  activeTab={activeTab4}
                                  refresh={refreshTable}
                                  props={props}
                                  updateSampleStatus={updateSampleStatus}
                                  labRequest={labRequest}
                                  users={users} advisers={advisers}
                                  id={props.match.params.id}
                                />
                              </TabPane>

                              <TabPane tabId="2">
                                <LabCitecDetailsTests generalStatus={labRequest.generalStatus} status={validation.values.requestStatus} activeTab={activeTab4} props={props} id={props.match.params.id} labRequest={labRequest} updateTestStatus={updateTestStatus} />
                              </TabPane>

                              <TabPane tabId="3">
                                {
                                  (activeTab4 === '3')
                                    ? <LabCitecDetailsReports generalStatus={labRequest.generalStatus} status={validation.values.requestStatus} activeTab={activeTab4} props={props} id={props.match.params.id} labRequest={labRequest} updateReportStatus={updateReportStatus} />
                                    : ''
                                }
                              </TabPane>
                            </TabContent>
                          </TabPane>

                          <TabPane
                            key={2}
                            tabId="2"
                          >
                            <LabCitecResultsTab generalStatus={labRequest.generalStatus} status={validation.values.requestStatus} activeTab={activeTab3} id={props.match.params.id} updateResultStatus={updateResultStatus} labRequest={labRequest} props={props} />
                          </TabPane>

                          <TabPane
                            key={3}
                            tabId="3"
                          >
                            <LabCitecSurveyTab generalStatus={labRequest.generalStatus} status={validation.values.requestStatus} activeTab={activeTab3} id={props.match.params.id} updateSurveyStatus={updateSurveyStatus} labRequest={labRequest} props={props} />
                          </TabPane>
                        </TabContent>
                      </TabPane>

                      <TabPane tabId="2">
                        {
                          (activeTab2 === '2')
                            ? <LabOperationTab generalStatus={labRequest.generalStatus} status={validation.values.requestStatus} props={props} id={props.match.params.id} updateLabOperationStatus={updateLabOperationStatus} labRequest={labRequest} updateTestStatus={updateTestStatus} />
                            : ''
                        }
                      </TabPane>
                    </TabContent>

                  </TabPane>

                  <TabPane tabId='2'>
                    <AssignmentsTab generalStatus={labRequest.generalStatus} props={props} id={props.match.params.id} updateAssignmentStatus={updateAssignmentStatus} labRequest={labRequest} />
                  </TabPane>

                  <TabPane tabId='3'>
                    <QuotationsTab generalStatus={labRequest.generalStatus} activeTab={activeTab} id={props.match.params.id} />
                  </TabPane>
                </TabContent>
              </Card>
              <br />
            </Card>
          </Col>
          <ToastContainer autoClose={2000} newestOnTop={true} />
        </Container>
      </div >
    </React.Fragment >
  )
}

export default withRouter(LabCitecDetails)
